import { Injectable } from '@angular/core';

import { SystemMessagesApi } from '../api/system-message-api';
import { ISystemMessage, ISystemMessageCategory, IUserSystemMessageStatus } from '../types';

const padSize = 2;

@Injectable({
    providedIn: 'root'
})
export class SystemMessagesService {
    constructor(public api: SystemMessagesApi) { }

    private pad(ret: string, num: number, str: string = '0') {
        return ret.padStart(num, str).slice(-num);
    }
    private dateString(date: Date) {
        return `${date.getFullYear()}-${this.pad((date.getMonth() + 1).toString(), padSize)}-${this.pad(date.getDate().toString(), padSize)}T${this.pad(date.getHours().toString(), padSize)}:${this.pad(date.getMinutes().toString(), padSize)}:${this.pad(date.getSeconds().toString(), padSize)}`;
    }
    private fixDates(message: ISystemMessage) {
        if (message) {
            if (message.startDate && typeof message.startDate !== 'string') {
                message.startDate = this.dateString(message.startDate) as any;
            }
            if (message.expirationDate && typeof message.expirationDate !== 'string') {
                message.expirationDate = this.dateString(message.expirationDate) as any;
            }
        }
        return message;
    }

    public async getAllMessages(): Promise<ISystemMessage[]> {
        return await this.api.getSystemMessages();
    }

    public async deleteSystemMessage(systemMessageId: number): Promise<boolean> {
        return await this.api.deleteSystemMessage(systemMessageId);
    }

    public async createSystemMessage(systemMessage: ISystemMessage, userId: number): Promise<ISystemMessage> {
        systemMessage.id = 0;
        systemMessage = this.cleanDataObjectForSave(systemMessage);
        return await this.api.saveSystemMessage(this.fixDates(systemMessage), userId);
    }

    public async saveSystemMessage(systemMessage: ISystemMessage, userId: number): Promise<ISystemMessage> {
        systemMessage = this.cleanDataObjectForSave(systemMessage);
        return await this.api.saveSystemMessage(this.fixDates(systemMessage), userId);
    }

    public async getUserMessageInbox(userId: number): Promise<IUserSystemMessageStatus[]> {
        return await this.api.getUserSystemMessageStatus(userId);
    }

    public async markUserMessageRead(userId: number, systemMessageId: number): Promise<IUserSystemMessageStatus> {
        return await this.api.saveUserSystemMessageStatus(systemMessageId, userId);
    }

    public async markUserMessageDismissed(userId: number, systemMessageId: number): Promise<IUserSystemMessageStatus> {
        return await this.api.saveUserSystemMessageStatus(systemMessageId, userId, true);
    }

    public async getSystemCategories(): Promise<ISystemMessageCategory[]> {
        return await this.api.getSystemMessageCategories();
    }

    private cleanDataObjectForSave(message: ISystemMessage) {
        if (message) {
            const cleanedMessage = { ...message };
            delete cleanedMessage.createDate;
            delete cleanedMessage.systemMessageCategory;
            return cleanedMessage;
        }
        return message;
    }
}
